module.exports = __webpack_public_path__ + "static/img/mc_240.9bf3b55.png";


//////////////////
// WEBPACK FOOTER
// ./static/mc_240.png
// module id = sZQg
// module chunks = 5